<script setup>
const preferencesStore = usePreferencesStore();
</script>

<template>
  <div class="flex items-center justify-center">
    <MoleculeNuxtIcon
      name="grid_view"
      class="mr-2 size-6 cursor-pointer transition-colors hover:scale-105 active:scale-95"
      :class="{
        'fill-secondary-blue-stroke dark:fill-white': preferencesStore.GET_VIEW_TYPE === 'grid',
        'fill-secondary-blue-stroke opacity-50 dark:fill-white':
          preferencesStore.GET_VIEW_TYPE !== 'grid',
      }"
      @click="preferencesStore.TOGGLE_VIEW_TYPE('grid')"
    />
    <MoleculeNuxtIcon
      name="list_view"
      class="size-6 cursor-pointer transition-colors hover:scale-105 active:scale-95"
      :class="{
        'fill-secondary-blue-stroke dark:fill-white': preferencesStore.GET_VIEW_TYPE === 'list',
        'fill-secondary-blue-stroke opacity-50 dark:fill-white':
          preferencesStore.GET_VIEW_TYPE !== 'list',
      }"
      @click="preferencesStore.TOGGLE_VIEW_TYPE('list')"
    />
  </div>
</template>
